<div style="display:block" class="ui-widget-overlay ui-front">
    <div style=" position:fixed; top: 50%; left: 50%; width: auto; height: auto;">
      <img src="assets/images/Rolling.gif">
    </div>
  </div>